import { Keyframe } from './domain.types';

// Constants for UI layout
export const KEYFRAME_ITEM_HEIGHT = 46;

// Asset interface for KeyframeManager
export interface Asset {
  asset_instance_id: string;
  startTime: number;
  duration: number;
  asset_instance_position?: string;
  asset_instance_rotation?: string;
  asset_instance_scale?: string;
}

export interface KeyframeManagerProps {
  sceneInstanceId: string;
  assetInstanceId: string;
  asset: Asset;
  assetCategory?: string;
  scale: number;
  isLocked: boolean;
  isVisible: boolean;
  selectedKeyframeId?: string | null;
  keyframes?: Keyframe[];
  itemHeight?: number;
  onKeyframeSelect?: (keyframeId: string | null, previousKeyframeId: string | null, assetInstanceId?: string, source?: 'timeline' | 'auto') => void;
  onLoadKeyframes?: (assetInstanceId: string) => void;
  onAddKeyframe?: (keyframe: Keyframe) => void;
  onUpdateKeyframe?: (keyframe: Keyframe) => void;
  onDeleteKeyframe?: (keyframeId: string) => void;
  onSelectKeyframe?: (keyframe: Keyframe, previousKeyframe: Keyframe | null, sceneInstanceId: string) => void;
  environmentPreferencesKeyframesOn?: boolean;
  // During resize, this tracks the current offset for visual compensation
  resizeOffset?: { side: 'left' | 'right'; deltaTime: number } | null;
  // Callback when drag positions change (for updating connecting line during drag)
  onDragPositionsChange?: (dragPositions: Record<string, number>) => void;
  /** Whether timeline is currently playing - disables keyframe interactions */
  isPlaying?: boolean;
}

export interface KeyframeContainerProps {
  assetInstanceId: string;
  assetStartTime: number;
  assetDuration: number;
  assetCategory?: string;
  scale: number;
  isLocked: boolean;
  isVisible: boolean;
  keyframes?: Keyframe[];
  onKeyframeAdd?: (assetInstanceId: string, timePosition: number) => void;
  onKeyframeMove?: (keyframeId: string, newTimePosition: number) => void;
  onKeyframeMoveEnd?: (keyframeId: string, originalTimePosition: number) => void;  
  onKeyframeSelect?: (keyframeId: string) => void;
  isKeyframeEditMode?: boolean; // Kept for now to avoid breaking changes
  isCurrentAssetInEditMode?: boolean; // Kept for now to avoid breaking changes
  selectedKeyframeId?: string | null;
  itemHeight?: number;
  // During resize, this tracks the current offset for visual compensation
  resizeOffset?: { side: 'left' | 'right'; deltaTime: number } | null;
  /** Whether timeline is currently playing - disables keyframe interactions */
  isPlaying?: boolean;
}

export interface KeyframeLineProps {
  assetInstanceId: string;
  assetStartTime: number;
  assetDuration: number;
  assetCategory?: string;
  scale: number;
  isLocked: boolean;
  isVisible: boolean;
  keyframes?: Keyframe[];
  onKeyframeAdd?: (assetInstanceId: string, timePosition: number) => void;
  onKeyframeMove?: (keyframeId: string, newTimePosition: number) => void;
  onKeyframeMoveEnd?: (keyframeId: string, originalTimePosition: number) => void;  
  onKeyframeSelect?: (keyframeId: string) => void;
  isKeyframeEditMode?: boolean; // Kept for now to avoid breaking changes
  isCurrentAssetInEditMode?: boolean; // Kept for now to avoid breaking changes
  selectedKeyframeId?: string | null;
  // During resize, this tracks the current offset for visual compensation
  resizeOffset?: { side: 'left' | 'right'; deltaTime: number } | null;
  itemHeight?: number;
  /** Whether timeline is currently playing - disables keyframe interactions */
  isPlaying?: boolean;
}

export interface KeyframeMarkerProps {
  keyframe: Keyframe;
  assetStartTime: number;
  assetDuration: number;
  scale: number;
  isLocked: boolean;
  isVisible: boolean;
  onMove?: (keyframeId: string, newTimePosition: number) => void;
  onMoveEnd?: (keyframeId: string, originalTimePosition: number) => void; 
  onSelect?: (keyframeId: string) => void;
  isSelected?: boolean;
  assetInstanceId: string;
  /** Whether timeline is currently playing - disables keyframe interactions */
  isPlaying?: boolean;
  /** Whether this is the last keyframe (excluding start marker) */
  isLastKeyframe?: boolean;
}

